import React from "react";
import Landing from "../sections/Landing";
import AboutCompanySection from "../sections/AboutCompanySection";
import OurProductsSection from "../sections/OurProductsSection";
import CompanyProfileSection from "../sections/CompanyProfileSection";
import ProductionLineSection from "../sections/ProductionLineSection";

export default function Home() {
    return (
        <>
            <Landing />
            <AboutCompanySection />
            <OurProductsSection />
            <CompanyProfileSection />
            <ProductionLineSection />
        </>
    );
}